import { getAdvBalanceSnapshots as Query } from "/public/graphQl/queries/getAnalytics";

export const getAdvAnalytics = async ({dispatch, rootGetters, commit}, payload) => {
  const organizationId = rootGetters['app/getSelectedOrganization'].id;

  let snapshotsData;

  commit('setAnalyticsLoading', true)

  try {
    snapshotsData = await dispatch('app/request', {
      type: 'query',
      gql: Query,
      variables: {
        organizationId,
        ...payload,
      },
    }, {root: true});
  } catch (error) {
    return error;
  }

  const { data } = snapshotsData || {}

  const { getAdvBalancesSnapshots } = data || {}

  commit('setAnalyticsLoading', false)
  commit('setAnalyticsInit', true)
  commit('setAnalytics', getAdvBalancesSnapshots ? [ getAdvBalancesSnapshots ] : [])

  return getAdvBalancesSnapshots ? [ getAdvBalancesSnapshots ] : [];
};